import styled from 'styled-components';
import theme from '../../styles/theme';
import React from 'react';
import NaviText from '../backoffice/common/NaviText';
import { useQuery } from 'react-query';
import { useEffect } from 'react';
import { useState } from 'react';
import { USER_MENU, USER_TP } from '../common/constants';
import { getMenu } from '../common/util';

const MainWrap = styled.div`
    padding: 0.5rem 1rem;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(40%, auto));
    gap: 1rem;
`
const Pannel = styled.a`
    background: ${theme.color.primary.main};
    border-radius: 16px;
    border: 0.5px solid ${theme.color.black[10]};
    padding: 1rem;
    transition: all 400ms ease-in-out, transform 400ms ease-in-out;
    text-align: center;
    text-decoration: none;
    color: ${theme.color.black[80]};
    &:active {
        background: ${theme.color.primary.main};
    }
`;

const Main = () => {

    const { data : user } = useQuery('USER', {});

    const [menu, setMenu] = useState({});


    useEffect(()=>{
        if(user && user.user_tp){
            switch(user.user_tp){
                case USER_TP.SUPER :
                    setMenu(getMenu('MOBILE','SUPER'));
                    break;
                case USER_TP.ADMIN :
                    setMenu(getMenu('MOBILE','ADMIN'));
                    break;
                case USER_TP.MANAGE :
                    setMenu(getMenu('MOBILE','MANAGE'));
                    break;
                case USER_TP.USER :
                    setMenu(getMenu('MOBILE','USER'));
                    break;
                case USER_TP.NORMAL :
                    setMenu(getMenu('MOBILE','NORMAL'));
                    break;
                default :
                    setMenu({})
                    break;
            }
        }
    },[user])

    return (
        <React.Fragment>
            {(menu && menu.main) &&
                menu.main.map((mainMenu,index)=>
                    <React.Fragment key={index}>
                        <h3 style={{margin:0,marginTop:16, padding:'0rem 1rem'}}>{mainMenu.TEXT}</h3>
                        <MainWrap>
                        {
                            menu.sub.filter((temp)=>temp.P_MENU===mainMenu.ID).map((subMenu,sIdx)=>
                            <Pannel key={sIdx} href={subMenu.URL}>
                                <img src={subMenu.ICON} /><br/>
                                {subMenu.TEXT}
                            </Pannel>
                            ) 
                        }
                        </MainWrap>
                    </React.Fragment>
                )
            }
        </React.Fragment>
    )
}

export default Main;